<template>
  <span>{{ timeAgo }} ago</span>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  date: string | Date
}>()

const timeAgo = computed(() => {
  const createdAt = new Date(props.date)
  const now = new Date()
  const diffTime = Math.abs(now.getTime() - createdAt.getTime())
  const diffHours = Math.floor(diffTime / (1000 * 60 * 60))
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24))

  const diffMonths = Math.floor(diffDays / 30)
  const diffYears = Math.floor(diffDays / 365)

  if (diffYears > 0) return `${diffYears}y`
  if (diffMonths > 0) return `${diffMonths}mo`
  if (diffDays > 0) return `${diffDays}d`
  if (diffHours > 0) return `${diffHours}h`
  return 'less than an hour'
})
</script> 